import normalizeHeight from '@fr/normalize-height';


// On document ready
$(function() {

  // Normalizes the press mention boxes to be the same height.
  normalizeHeight($('.press-mentions-entry'));

});
